import { render } from "./intersect.vue?vue&type=template&id=4fe8da2e"
import script from "./intersect.vue?vue&type=script&setup=true&lang=ts"
export * from "./intersect.vue?vue&type=script&setup=true&lang=ts"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "4fe8da2e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4fe8da2e', script)) {
    api.reload('4fe8da2e', script)
  }
  
  module.hot.accept("./intersect.vue?vue&type=template&id=4fe8da2e", () => {
    api.rerender('4fe8da2e', render)
  })

}

script.__file = "resources/scripts/components/ui/intersect.vue"

export default script